// Reconstitution de l'état des habilitations nominatives à partir du journal d'audit.
// L'API du lot L0-A n'expose pas de liste des habilitations (seulement création, validation,
// révocation) : le journal, en écriture seule, est la source réelle disponible.
import type { EntreeAudit } from '../../api/types';

export interface HabilitationReconstituee {
  id: string;
  appartenance_id: string | null;
  zone: string;
  domaines: string[];
  motif: string | null;
  debut: string | null;
  fin: string | null;
  statut: 'en_attente_validation' | 'validee' | 'revoquee';
  cree_le: string;
}

interface ApresCreation {
  appartenance_id?: string;
  zone?: string;
  perimetre?: { domaines?: string[] };
  motif?: string;
  debut?: string;
  fin?: string;
}

/** Entrées triées de la plus récente à la plus ancienne (ordre de GET /audit). */
export function reconstituerHabilitations(entrees: EntreeAudit[]): HabilitationReconstituee[] {
  const parId = new Map<string, HabilitationReconstituee>();
  const chronologique = [...entrees].sort((a, b) => Number(a.rang) - Number(b.rang));
  for (const e of chronologique) {
    if (e.objet_type !== 'habilitation' || !e.objet_id) continue;
    if (e.action === 'habilitation.creation') {
      const a = (e.apres ?? {}) as ApresCreation;
      parId.set(e.objet_id, {
        id: e.objet_id,
        appartenance_id: a.appartenance_id ?? null,
        zone: a.zone ?? 'inconnue',
        domaines: a.perimetre?.domaines ?? [],
        motif: a.motif ?? null,
        debut: a.debut ?? null,
        fin: a.fin ?? null,
        statut: 'en_attente_validation',
        cree_le: e.horodatage,
      });
    } else {
      const h = parId.get(e.objet_id);
      if (!h) continue;
      if (e.action === 'habilitation.validation') h.statut = 'validee';
      if (e.action === 'habilitation.revocation') h.statut = 'revoquee';
    }
  }
  return [...parId.values()].sort((a, b) => b.cree_le.localeCompare(a.cree_le));
}

export const LIBELLES_ZONES: Record<string, string> = {
  personnel_sensible: 'Personnel (données sensibles)',
  social: 'Action sociale',
  reclamation_sensible: 'Réclamations sensibles',
  mission: 'Mission (lecture et export)',
};
